// Parshva S - 15/11/2023 BT-102679 - Breeze- Multi Leg order entry - start
import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { BzButton } from '../../../components';
import { TL_INDEX, ORDER_ENTRY_BUTTON_TOGGLE, WATCHLIST_GRID_INDEX, MARKET_SEGMENT_ID, DISPLAY_EXCHANGE_NAME, SCRIP_INSTRUMENTS } from "../../../utils/global_variables";
import { useWFHMessages } from '../../../hooks';
import { sendTouchlineRequest } from '../../../apis/web_socket';
import { useDispatch, useSelector } from 'react-redux';
import { handleModal } from '../../../redux/actions/modals';
import moment from 'moment';
import { getWfhTouchlineLastTick } from '../../../redux/actions/wfh';
import { LoginLoader } from '../../Login';
import { _getExpiryForScrip } from '../../../controllers/orders';
const Future = ({ legNumber = 0, setThirdLegData, areFutureContractsDisabled, }) => {

    const [addLegdata, setAddLegData] = useState([]);
    const [arrExiryList, setArrExipryList] = useState([]);
    
    const multiLegData = useSelector(state => state.orders?.multiLegData);
    const whatsHotData = useSelector(state => state.dontMiss.whatsHotData);
    const orderInfo = useSelector(state => state.orders?.scripOrderInfo?.scripData);
    
    const handleGetExpiryForScripFromApi = useCallback(async () => {
        const list = await _getExpiryForScrip(whatsHotData, {
            segment_id: orderInfo?.[WATCHLIST_GRID_INDEX?.SEGMENT_ID],
            symbol:orderInfo?.[WATCHLIST_GRID_INDEX.NSPREAD]===1 ? multiLegData[0]?.extraInfo[WATCHLIST_GRID_INDEX.SYMBOL]:orderInfo?.[WATCHLIST_GRID_INDEX.SYMBOL],
            instrument: orderInfo?.[WATCHLIST_GRID_INDEX.EXCHANGE]?.includes(DISPLAY_EXCHANGE_NAME.MCX_EXCHANGE_TEXT) || orderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.BSECOMM_DERIVATIVES ? SCRIP_INSTRUMENTS.FUTCOM
                : orderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] === MARKET_SEGMENT_ID.NSECOMM_DERIVATIVES ? SCRIP_INSTRUMENTS.FUTBLN : 'FUT' + orderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT]?.substr(3, 3)
        });
        Promise.resolve(list).then((data) => {
            setArrExipryList(prevState => {
                if (prevState?.length === 0) {
                    return [...data];
                } else {

                    return prevState;
                }
            });
        }, (error) => {
            console.error("Error in fetching data", error);
        });
    }, [orderInfo, whatsHotData]);
    useEffect(() => {
        handleGetExpiryForScripFromApi();
    }, [handleGetExpiryForScripFromApi]);
    const dispatch = useDispatch();
    const arrScripsForSubscription = useMemo(() => arrExiryList?.map(scrip => ({ exchangeId: scrip?.MktSegId, token: scrip?.nToken, isSubscribe: true })), [arrExiryList]);
    // Ajitesh 31-07-2024 Adss state var to track loading
    const [isFuturesDataLoading, setIsFuturesDataLoading] = useState(false);
    const addScript = useCallback((element, option) => {
        setThirdLegData(element, option);
        dispatch(handleModal([{ "ADD_LEG_MODAL": false }]));
    }, [dispatch, setThirdLegData]);
    useWFHMessages('touchline', (e) => {
        let arrEdetails = [...addLegdata];
        if (addLegdata.length === 0) return;
        arrExiryList.forEach((each) => {
            if (each?.MktSegId === e.detail[TL_INDEX.SEGMENT_ID] && each?.nToken === e.detail[TL_INDEX.TOKEN]) {
                let detail = each?.MktSegId === e.detail[TL_INDEX.SEGMENT_ID] && each?.nToken === e.detail[TL_INDEX.TOKEN] ? e.detail : null;
                const nIndex = addLegdata?.findIndex(each => each.segmentId === e.detail[TL_INDEX.SEGMENT_ID] && each.token === e.detail[TL_INDEX.TOKEN]);
                if (nIndex !== -1) {
                    arrEdetails[nIndex] = {
                        ...arrEdetails[nIndex],
                        changeInLtp: e.detail?.[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE],
                        ltpPercent: e.detail?.[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE],
                        ltp: e.detail?.[TL_INDEX.LAST_TRADE_PRICE],
                        tlData: detail,
                        premiumDiscount: isNaN((parseFloat(orderInfo?.[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]) - parseFloat(e.detail?.[TL_INDEX.LAST_TRADE_PRICE])).toFixed(orderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH])) ? '0.00' : (parseFloat(orderInfo?.[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]) - parseFloat(e.detail?.[TL_INDEX.LAST_TRADE_PRICE])).toFixed(orderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH])

                    };
                }
            }
        });
        if (arrEdetails.length === 0) {
        } else {
            setAddLegData(arrEdetails);
        }
    });

    useEffect(() => {
        sendTouchlineRequest(arrScripsForSubscription);
    }, [arrScripsForSubscription]);


    useEffect(() => {
        if (arrExiryList?.length > 0 && addLegdata?.length === 0) {
            setIsFuturesDataLoading(true);

            setTimeout(() => {
                let info = dispatch(getWfhTouchlineLastTick());
                let temp = arrExiryList.map(each => {
                    let tempInfo = info[`${each?.MktSegId}_${each?.nToken}`];
                    let arrDefaultTouchLineData = new Array(Math.max(...Object.values(TL_INDEX))).fill(''); // as written in case od edge case if extra info not htere simulated in 1651 uat1 env
                    arrDefaultTouchLineData[TL_INDEX.SEGMENT_ID] = each?.MktSegId;
                    arrDefaultTouchLineData[TL_INDEX.TOKEN] = each?.nToken;
                    return {
                        expiryDate: each?.nExpiryDate1,
                        token: each?.nToken,
                        segmentId: each?.MktSegId,
                        exchange: each?.sExchange,
                        ask_qty: each?.nRegularLot,
                        changeInLtp: tempInfo?.[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE],
                        ltpPercent: tempInfo?.[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE],
                        ltp: tempInfo?.[TL_INDEX.LAST_TRADE_PRICE],
                        tlData: tempInfo ?? arrDefaultTouchLineData,
                        premiumDiscount: isNaN((parseFloat(orderInfo?.[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]) - parseFloat(tempInfo?.[TL_INDEX.LAST_TRADE_PRICE])).toFixed(orderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH])) ? '0.00' : (parseFloat(orderInfo?.[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]) - parseFloat(tempInfo?.[TL_INDEX.LAST_TRADE_PRICE])).toFixed(orderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH])
                    };
                });
                setAddLegData(temp);
                setIsFuturesDataLoading(false);
            }, 300);
        }
    }, [addLegdata, dispatch, legNumber, arrExiryList, orderInfo]);

    return (
        <>
            {
                // Ajitesh 31-07-2024 Loader for futures   
                isFuturesDataLoading ?
                    <Container className='p-0 py-5'>
                        <Row className='g-0'>
                            <Col className='d-flex justify-content-center align-items-center'>
                                <LoginLoader spinner={isFuturesDataLoading} spinnerContent="Loading futures" />
                            </Col>
                        </Row>
                    </Container> : null
            }
            <Container fluid className='p-0'>
                {addLegdata?.length > 0 && addLegdata.map((element, indMultileg) =>
                    <Row className='g-0 py-3' key={indMultileg}>
                        <>
                            <Col md={5} className='d-flex flex-column'>
                                <div className='font-medium font-size3 color-text text-uppercase'>{moment(element?.expiryDate, 'DDMMMYYYY').format("DD MMM 'YY")}</div>
                                <div className='font-regular font-size2 color-subtext'>Premium Discount <span className='color-text'>{element?.premiumDiscount || "0.00"}</span></div>
                            </Col>
                            <Col md={5} className='d-flex justify-content-end align-items-center'>
                                <div className='font-medium font-size4 color-text me-2'>{element?.ltp || "0.00"}</div>
                                <div className={`font-regular font-size4 color-text ${parseFloat(element?.ltpPercent) >= 0 ? 'color-positive' : 'color-negative'}`}>{element?.changeInLtp || "0.00"} ({element?.ltpPercent || "0.00"}%)</div> {/**Ajitesh 26-07-2024 greena dn red color classes for LTP in futures tab */}
                            </Col>
                            <Col md={2} className='d-flex justify-content-end align-items-center'>
                                <BzButton className={`btn btn-sm btn-positive text-capitalize ms-2`} disabled={multiLegData?.findIndex(each => each?.token === element?.token) !== -1 || areFutureContractsDisabled} onClick={() => { addScript(element, ORDER_ENTRY_BUTTON_TOGGLE?.BUY); }}>B</BzButton>{/* Parshva S: BT: 107070 : 2/3/24 */} {/**Ajitesh 09-07-2024 If user selects third leg in option chain screen disable all buttons in Futures tab */}
                                <BzButton className={`btn btn-sm btn-negative text-capitalize ms-2`} disabled={multiLegData?.findIndex(each => each?.token === element?.token) !== -1 || areFutureContractsDisabled} onClick={() => { addScript(element, ORDER_ENTRY_BUTTON_TOGGLE?.SELL); }}>S</BzButton>{/* Parshva S: BT: 107070 : 2/3/24 */} {/**Ajitesh 09-07-2024 If user selects third leg in option chain screen disable all buttons in Futures tab */}
                            </Col>
                        </>

                    </Row>

                )

                }

            </Container>
        </>
    );
};

export default memo(Future);
// Parshva S - 15/11/2023 BT-102679 - Breeze- Multi Leg order entry - end